<template>
  <div class="page 404">
    <v-container class="page-content mt-8 mb-8 px-4 ">
       <v-img
          alt="error 404"
          contain
          :src="require('../assets/404.png')"
          transition="scale-transition"
          height="270"
        />
        <v-btn class="btn-detail px-7" rounded @click="onClick()">回到首页</v-btn>
    </v-container>
    <CFooter></CFooter>
  </div>
</template>

<script>
import CFooter from '@/components/Common/Footer'
export default {
  name: 'NotFound',
  components: {
    CFooter
  },
  methods: {
    onClick () {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="scss" scoped>
  .page-content {
    padding-top: 100px;
    padding-bottom: 100px;
    position: relative;
    .btn-detail {
      position: absolute;
      top: 124px;
      left: calc(50% - 50px);
      width: 100px;
      height: 27px;
      background-color: transparent!important;
      font-size: 0;
      border: none;
      box-shadow: none;
      &:hover {
        box-shadow: none;
        background-color: transparent!important;
      }
      &:before {
        display: none;
      }
    }
  }
</style>
